import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  needsCaseListRefresh: false,
};

export const caseRefreshSlice = createSlice({
  name: "caseRefresh",
  initialState,
  reducers: {
    setCaseListRefresh: (state, action) => {
      state.needsCaseListRefresh = action.payload;
    },
  },
});

export const { setCaseListRefresh } = caseRefreshSlice.actions;

export default caseRefreshSlice.reducer;
